type UserRole = 'AppSupportAdmin' | 'AppAdmin' | 'AppLead' | 'AppUser';

export const getHighestRole = (roles: UserRole[]): UserRole | undefined => {
  if (roles.includes('AppSupportAdmin')) {
    return 'AppSupportAdmin';
  }

  if (roles.includes('AppAdmin')) {
    return 'AppAdmin';
  }

  if (roles.includes('AppLead')) {
    return 'AppLead';
  }

  if (roles.includes('AppUser')) {
    return 'AppUser';
  }
};

export default UserRole;
